//minutes since midnight
import { getMinutesSinceMidnight, getLocalisedDayOfWeek } from "./date-utils";
import moment from "moment";

const DEFAULT_TIMESLOTS_BUFFER = 5;
const SKIP_BUFFER_PERIODS = {
    MORNING_PERIOD_START: 820,
    MORNING_PERIOD_END: 960,
    AFTERNOON_PERIOD_START: 1220,
    AFTERNOON_PERIOD_END: 1440,
};

export const isCurrentTimeInSkipBufferPeriod = () => {
    const timeSinceMidnight = getMinutesSinceMidnight();
    const inMorningPeriod =
        timeSinceMidnight > SKIP_BUFFER_PERIODS.MORNING_PERIOD_START &&
        timeSinceMidnight < SKIP_BUFFER_PERIODS.MORNING_PERIOD_END;
    const inAfternoonPeriod =
        timeSinceMidnight > SKIP_BUFFER_PERIODS.AFTERNOON_PERIOD_START &&
        timeSinceMidnight < SKIP_BUFFER_PERIODS.AFTERNOON_PERIOD_END;

    return inMorningPeriod || inAfternoonPeriod;
};

/**
 * Finds first available timeslot
 * otherwise undefined
 */
export const getFirstAvailableTimeslot = (
    timeSlotArray,
    selectedDay = false,
    withBuffer = false
) => {
    const buffer = reactConfig.slotBufferTime || DEFAULT_TIMESLOTS_BUFFER;

    try {
        const currentTime = moment();
        const withinSkipBufferPeriod = isCurrentTimeInSkipBufferPeriod();
        const lastSlotOfCurrentShift = getLastSlotOfCurrentShift(
            timeSlotArray,
            selectedDay
        );

        return timeSlotArray.find((timeSlot) => {
            if (!timeSlot.free) {
                return false;
            }

            // Do not apply 10 min buffer if flag is set to false or if time slot is last of the day or current time is within skip Buffer period
            if (
                !withBuffer ||
                timeSlot.id === lastSlotOfCurrentShift ||
                withinSkipBufferPeriod
            ) {
                return true;
            }

            // Check if outside buffer
            const timeslotEnd = moment(timeSlot.valid_till);
            const timeDiff = timeslotEnd.diff(currentTime, "minutes");
            if (timeDiff >= buffer) {
                return true;
            }
        });
    } catch (e) {
        return undefined;
    }
};

/**
 * Return Id of the last time slot of current shift (client side)
 */
export const getLastSlotOfCurrentShift = (
    timeSlotsArray,
    selectedDay = false
) => {
    const today = selectedDay ? moment(selectedDay).day() : moment().day();

    const minutesSinceMidnight = getMinutesSinceMidnight();
    const timeSlotsToday = timeSlotsArray.filter((timeSlot) => {
        return moment(timeSlot.valid_till).day() === today;
    });
    const morningShift = timeSlotsToday.filter((timeSlot) => {
        const startOfToday = moment(timeSlot.valid_till).startOf("day");
        const timeSinceMidnight = moment(timeSlot.valid_till).diff(
            startOfToday,
            "minutes"
        );

        return timeSinceMidnight < SKIP_BUFFER_PERIODS.MORNING_PERIOD_END;
    });

    const afternoonShift = timeSlotsToday.filter((timeSlot) => {
        const startOfToday = moment(timeSlot.valid_till).startOf("day");
        const timeSinceMidnight = moment(timeSlot.valid_till).diff(
            startOfToday,
            "minutes"
        );

        return (
            timeSinceMidnight > SKIP_BUFFER_PERIODS.MORNING_PERIOD_END &&
            timeSinceMidnight < SKIP_BUFFER_PERIODS.AFTERNOON_PERIOD_END
        );
    });

    //return last timeslot in the morning shift
    if (
        minutesSinceMidnight < SKIP_BUFFER_PERIODS.MORNING_PERIOD_END &&
        morningShift.length > 0
    ) {
        return morningShift[morningShift.length - 1].id;
    }

    //return last timeslot in the afternoon shift
    return afternoonShift[afternoonShift.length - 1].id;
};

export const formatDateToHours = (date) => moment(date).format("H:mm");

export const formatDateToDayAndHours = (date) => `${getLocalisedDayOfWeek(date)}, ${formatDateToHours(date)}`;

export const formatTimeslotEntryFromCart = (start, end) => {
    if (!start || !end) {
        return "";
    }

    const [startDate, endDate] = [new Date(start), new Date(end)];
    const day = getLocalisedDayOfWeek(endDate);
    const [from, to] = [
        formatDateToHours(startDate),
        formatDateToHours(endDate),
    ];

    return `${day}, ${from} - ${to} Uhr`;
};

export const formatMembersTimeslotEntryFromCart = (expirationDate) => {
    if (!expirationDate) {
        return "";
    }

    const day = getLocalisedDayOfWeek(expirationDate);
    const to = formatDateToHours(expirationDate);

    return `${day}, ${to} Uhr`;
};
